
import React, { useEffect, useState } from "react";
import axios from "axios";

const Dailynewusers = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ================= API URL =================
  // Apna backend URL yaha set karo
  const API_URL = "https://apiexpert.expertludo.com/users/daily-new";

  // ================= GET USERS =================
  const getDailyNewUsers = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(API_URL, {
        params: {
          date: selectedDate,
        },
      });

      if (response.data?.status === 200) {
        setUsers(response.data.users || []);
        setTotalUsers(response.data.totalUsers || 0);
      } else {
        setUsers([]);
        setTotalUsers(0);
        setError(response.data?.msg || "Unable to fetch users");
      }
    } catch (err) {
      console.error("Daily New Users Error:", err);

      setUsers([]);
      setTotalUsers(0);
      setError(
        err?.response?.data?.msg ||
          err?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  // ================= DATE CHANGE =================
  useEffect(() => {
    getDailyNewUsers();
  }, [selectedDate]);

  // ================= FORMAT DATE =================
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // ================= FORMAT TIME =================
  const formatTime = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="daily-new-users-page">

      {/* ================= HEADER ================= */}
      <div className="daily-new-users-header">
        <div>
          <h2>Daily New Users</h2>
          <p>
            View users who registered on the selected date
          </p>
        </div>

        <button
          className="refresh-btn"
          onClick={getDailyNewUsers}
          disabled={loading}
        >
          {loading ? "Loading..." : "↻ Refresh"}
        </button>
      </div>

      {/* ================= FILTER ================= */}
      <div className="daily-new-users-filter">

        <div className="date-box">
          <label>Select Date</label>

          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        {/* ================= TOTAL ================= */}
        <div className="total-users-card">
          <div className="total-icon">👤</div>

          <div>
            <span>Total New Users</span>
            <strong>{totalUsers}</strong>
          </div>
        </div>

      </div>

      {/* ================= ERROR ================= */}
      {error && (
        <div className="error-box">
          {error}
        </div>
      )}

      {/* ================= TABLE ================= */}
      <div className="users-table-card">

        <div className="table-header">
          <div>
            <h3>New Users List</h3>
            <span>
              {formatDate(selectedDate)}
            </span>
          </div>

          <div className="user-count">
            {totalUsers} Users
          </div>
        </div>

        <div className="table-wrapper">

          <table className="users-table">

            <thead>
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Referral</th>
                <th>Referral Code</th>
                <th>Joined Date</th>
                <th>Joined Time</th>
              </tr>
            </thead>

            <tbody>

              {/* ================= LOADING ================= */}
              {loading ? (
                <tr>
                  <td colSpan="8">
                    <div className="loading-box">
                      <div className="loader"></div>
                      <span>Loading users...</span>
                    </div>
                  </td>
                </tr>
              ) : users.length === 0 ? (

                /* ================= EMPTY ================= */
                <tr>
                  <td colSpan="8">
                    <div className="empty-box">
                      <div className="empty-icon">
                        👤
                      </div>

                      <h4>No New Users</h4>

                      <p>
                        No users registered on{" "}
                        {formatDate(selectedDate)}
                      </p>
                    </div>
                  </td>
                </tr>

              ) : (

                /* ================= USERS ================= */
                users.map((user, index) => (

                  <tr key={user._id || index}>

                    <td>
                      <span className="serial-number">
                        {index + 1}
                      </span>
                    </td>

                    <td>
                      <div className="user-info">

                        <div className="user-avatar">
                          {user?.Name
                            ? user.Name.charAt(0).toUpperCase()
                            : "U"}
                        </div>

                        <div>
                          <strong>
                            {user?.Name || "-"}
                          </strong>

                          <small>
                            ID: {user?._id || "-"}
                          </small>
                        </div>

                      </div>
                    </td>

                    <td>
                      <span className="phone-number">
                        {user?.Phone || "-"}
                      </span>
                    </td>

                    <td>
                      {user?.Email || "-"}
                    </td>

                    <td>
                      {user?.referral ? (
                        <span className="referral-badge">
                          {user.referral}
                        </span>
                      ) : (
                        <span className="no-referral">
                          Direct
                        </span>
                      )}
                    </td>

                    <td>
                      {user?.referral_code ? (
                        <span className="referral-code">
                          {user.referral_code}
                        </span>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      {formatDate(user?.createdAt)}
                    </td>

                    <td>
                      <span className="time-badge">
                        {formatTime(user?.createdAt)}
                      </span>
                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>
      </div>

      {/* ================= CSS ================= */}
      <style>{`

        * {
          box-sizing: border-box;
        }

        .daily-new-users-page {
          width: 100%;
          min-height: 100vh;
          padding: 25px;
          background: #f5f7fb;
          font-family: Arial, Helvetica, sans-serif;
          color: #1f2937;
        }

        /* HEADER */

        .daily-new-users-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 25px;
          gap: 20px;
        }

        .daily-new-users-header h2 {
          margin: 0 0 6px;
          font-size: 26px;
          font-weight: 700;
          color: #111827;
        }

        .daily-new-users-header p {
          margin: 0;
          color: #6b7280;
          font-size: 14px;
        }

        .refresh-btn {
          border: none;
          background: #111827;
          color: white;
          padding: 11px 18px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          transition: 0.2s;
        }

        .refresh-btn:hover {
          background: #000;
          transform: translateY(-1px);
        }

        .refresh-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* FILTER */

        .daily-new-users-filter {
          display: flex;
          align-items: stretch;
          justify-content: space-between;
          gap: 20px;
          margin-bottom: 22px;
        }

        .date-box {
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          padding: 16px;
          width: 300px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.03);
        }

        .date-box label {
          display: block;
          font-size: 13px;
          color: #6b7280;
          margin-bottom: 8px;
          font-weight: 600;
        }

        .date-box input {
          width: 100%;
          height: 42px;
          border: 1px solid #d1d5db;
          border-radius: 7px;
          padding: 0 12px;
          font-size: 14px;
          outline: none;
          color: #111827;
          background: white;
        }

        .date-box input:focus {
          border-color: #111827;
        }

        /* TOTAL CARD */

        .total-users-card {
          flex: 1;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          padding: 16px 20px;
          display: flex;
          align-items: center;
          gap: 15px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.03);
        }

        .total-icon {
          width: 48px;
          height: 48px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f3f4f6;
          font-size: 22px;
        }

        .total-users-card span {
          display: block;
          color: #6b7280;
          font-size: 13px;
          margin-bottom: 4px;
        }

        .total-users-card strong {
          display: block;
          font-size: 25px;
          color: #111827;
        }

        /* ERROR */

        .error-box {
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #b91c1c;
          padding: 13px 15px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 14px;
        }

        /* TABLE CARD */

        .users-table-card {
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.03);
        }

        .table-header {
          min-height: 70px;
          padding: 15px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #e5e7eb;
        }

        .table-header h3 {
          margin: 0 0 4px;
          font-size: 17px;
          color: #111827;
        }

        .table-header span {
          font-size: 13px;
          color: #6b7280;
        }

        .user-count {
          padding: 7px 12px;
          border-radius: 20px;
          background: #f3f4f6;
          color: #374151;
          font-size: 13px;
          font-weight: 600;
        }

        .table-wrapper {
          width: 100%;
          overflow-x: auto;
        }

        .users-table {
          width: 100%;
          min-width: 1050px;
          border-collapse: collapse;
        }

        .users-table th {
          background: #f9fafb;
          color: #6b7280;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.4px;
          font-weight: 700;
          padding: 14px 15px;
          text-align: left;
          border-bottom: 1px solid #e5e7eb;
          white-space: nowrap;
        }

        .users-table td {
          padding: 14px 15px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 13px;
          color: #374151;
          white-space: nowrap;
        }

        .users-table tbody tr {
          transition: background 0.15s;
        }

        .users-table tbody tr:hover {
          background: #fafafa;
        }

        .serial-number {
          color: #9ca3af;
          font-weight: 600;
        }

        /* USER */

        .user-info {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .user-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #111827;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 700;
          flex-shrink: 0;
        }

        .user-info strong {
          display: block;
          color: #111827;
          font-size: 13px;
          margin-bottom: 3px;
        }

        .user-info small {
          display: block;
          color: #9ca3af;
          font-size: 10px;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .phone-number {
          font-weight: 600;
          color: #374151;
        }

        /* BADGES */

        .referral-badge {
          display: inline-block;
          padding: 5px 9px;
          border-radius: 5px;
          background: #f3f4f6;
          color: #374151;
          font-size: 11px;
          font-weight: 600;
        }

        .no-referral {
          color: #9ca3af;
          font-size: 12px;
        }

        .referral-code {
          font-family: monospace;
          font-size: 12px;
          font-weight: 600;
          color: #374151;
        }

        .time-badge {
          padding: 5px 8px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 5px;
          font-size: 11px;
          color: #4b5563;
        }

        /* LOADING */

        .loading-box {
          min-height: 250px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          color: #6b7280;
        }

        .loader {
          width: 32px;
          height: 32px;
          border: 3px solid #e5e7eb;
          border-top-color: #111827;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        /* EMPTY */

        .empty-box {
          min-height: 280px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .empty-icon {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: #f3f4f6;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          margin-bottom: 12px;
        }

        .empty-box h4 {
          margin: 0 0 5px;
          color: #374151;
          font-size: 15px;
        }

        .empty-box p {
          margin: 0;
          color: #9ca3af;
          font-size: 13px;
        }

        /* RESPONSIVE */

        @media (max-width: 768px) {

          .daily-new-users-page {
            padding: 15px;
          }

          .daily-new-users-header {
            align-items: flex-start;
            flex-direction: column;
          }

          .daily-new-users-header h2 {
            font-size: 22px;
          }

          .daily-new-users-filter {
            flex-direction: column;
          }

          .date-box {
            width: 100%;
          }

          .total-users-card {
            width: 100%;
          }

        }

      `}</style>

    </div>
  );
};

export default Dailynewusers;
